import api from '../services/api';

// Get all tasks for calendar
export const getTasks = async () => {
  try {
    const response = await api.get('/calendar/tasks');
    return response.data;
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};

// Create a new task
export const createTask = async (taskData) => {
  try {
    const response = await api.post('/calendar/tasks', taskData);
    return response.data;
  } catch (error) {
    console.error('Error creating task:', error);
    throw error;
  }
};

// Update an existing task
export const updateTask = async (taskData) => {
  try {
    const response = await api.put('/calendar/tasks', taskData);
    return response.data;
  } catch (error) {
    console.error('Error updating task:', error);
    throw error;
  }
};

// Delete a task
export const deleteTask = async (taskId) => {
  try {
    const response = await api.delete(`/calendar/tasks/${taskId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting task:', error);
    throw error;
  }
};

// Update task time/billing
export const updateTaskTime = async (taskData) => {
  try {
    const response = await api.put('/calendar/time', taskData);
    return response.data;
  } catch (error) {
    console.error('Error updating task time:', error);
    throw error;
  }
};